import React, { type ReactNode } from 'react'
export interface FormInfo {
  className?: string
  children: ReactNode | string | JSX.Element | React.ReactElement
  isError?: boolean
  borderColor?: string
  textSize?: string
}

export function FormInfo({
  className = '',
  children,
  textSize,
  isError = false,
  borderColor = 'border-states-success',
}: FormInfo) {
  return (
    <div
      className={`flex flex-row items-center border
       p-3 ${
         isError ? 'border-states-error' : `${borderColor} bg-gray-medium`
       } rounded ${className}`}
    >
      <div className={`body-paragraph-regular ${textSize}`}>{children}</div>
    </div>
  )
}

export default FormInfo
